import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
  EvidenceUploadSetting,
  IEvidenceUploadSettingList,
} from '../models/evidence-upload-setting';
import { BaseRestService } from './base-rest.service';
import { forkJoin, of, Subscription, Observable } from 'rxjs';
import { OrganisationService } from './organisation.service';
import { SubjectTypeService } from './subject-type.service';
import { map, take } from 'rxjs/operators';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root' })
export class EvidenceUploadSettingService
  extends BaseRestService<EvidenceUploadSetting, IEvidenceUploadSettingList>
  implements OnDestroy
{
  organisationSaved: Subscription;
  organisationDeleted: Subscription;

  constructor(
    http: HttpClient,
    protected router: Router,
    private organisationService: OrganisationService,
    private subjectTypeService: SubjectTypeService
  ) {
    super(
      EvidenceUploadSettingService,
      http,
      'api/evidenceuploadsettings',
      'evidence upload setting',
      router
    );
    this.cacheEnabled = true;

    this.organisationSaved = this.organisationService.onAfterSave.subscribe(
      (_) => {
        this.clearCache();
      }
    );

    this.organisationDeleted = this.organisationService.onDeleted.subscribe(
      (_) => {
        this.clearCache();
      }
    );
  }

  ngOnDestroy() {
      this.organisationSaved?.unsubscribe();
      this.organisationDeleted?.unsubscribe();
  }

  afterSave() {
    this.subjectTypeService.refresh();
  }

  hydrate(item: EvidenceUploadSetting): Observable<EvidenceUploadSetting> {
    const hydrate$ = [];
    if (
      (item.organisationId && !item.organisation) ||
      (item.organisation && item.organisation.id !== item.organisationId)
    ) {
      hydrate$.push(
        this.organisationService.getById(item.organisationId).pipe(
          map((organisation) => {
            item.organisation = organisation;
            return item;
          })
        )
      );
    }

    if (hydrate$.length > 0) {
      return forkJoin(hydrate$).pipe(
        take(1),
        map((_) => {
          return item;
        })
      );
    } else {
      return of(item);
    }
  }
}
